var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvironmentalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 2L64 18V50L34 66L4 50V18L34 2Z",
    fill: "#E8F5E9",
    stroke: "#2E7D32",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8333 43.3333C30.7847 43.3395 28.8086 42.5756 27.2969 41.193C25.7852 39.8104 24.8483 37.9101 24.6721 35.8691C24.4959 33.8281 25.0932 31.7954 26.3456 30.1742C27.598 28.553 29.4139 27.4616 31.4333 27.1166C38.0833 25.8333 39.8333 25.2266 42.1666 22.3333C43.3333 24.6666 44.4999 27.21 44.4999 31.6666C44.4999 38.0833 38.9233 43.3333 32.8333 43.3333Z",
    stroke: "#2E7D32",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 44.5C22.3333 41 24.4916 38.2467 28.2599 37.5C31.0833 36.94 33.9999 35.1667 35.1666 34",
    stroke: "#2E7D32",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalIcon);
export default __webpack_public_path__ + "static/media/EnvironmentalIcon.aa85aa727a16af8d82afe6681db940c6.svg";
export { ForwardRef as ReactComponent };